import {useCallback} from 'react';
import {useSelector} from 'react-redux';
import type {RootState} from '@/store';
import {useAppDispatch} from '@/hooks';
import {setAudioLimitState, setIsFetchingAudioLimit, setAudioLimitFetchError} from '@/ai-chat/ai-chat.reducer';
import {fetchAudioLimitStatus} from '@Libraries/speech-to-text.library';

export enum MicState {
  IDLE = 'idle',
  LOADING = 'loading',
  READY = 'ready',
  LIMITED = 'limited',
  ERROR = 'error',
}

export const useAudioLimit = () => {
  const dispatch = useAppDispatch();
  const audioLimit = useSelector((state: RootState) => state.aiChat.audioLimit);

  const fetchStatus = useCallback(async (): Promise<void> => {
    dispatch(setIsFetchingAudioLimit(true));
    try {
      const limit = await fetchAudioLimitStatus();
      dispatch(setAudioLimitState(limit));
    } catch (e) {
      dispatch(setAudioLimitFetchError());
    }
  }, [dispatch]);

  const handleFocus = useCallback((): void => {
    if (audioLimit.lastSyncedAt === null) return;
    const isStale = Date.now() - new Date(audioLimit.lastSyncedAt).getTime() > 30_000;
    if (isStale) {
      void fetchStatus();
    }
  }, [audioLimit.lastSyncedAt, fetchStatus]);

  return {fetchStatus, handleFocus};
};
